<template>
    <v-text-field 
        hide-details
        outlined
        height="18"
        color="black"
        :background-color="item.level === 0? '#A9C5C3' : '#F5F5F5'"
        style="font-size: 12px;"
        :style="item.level === 0? 'font-weight: 700;' : 'font-weight: 400;'"
        @focus="$emit('focus')"
        @keyup="$emit('keyup')"
        :value="value"
        @input.native="$emit('update:value', $event.srcElement.value)"
        class="font-theme input-each-group-dashboard-budget centered-input-dashboard-budget"
        v-currency="{ distractionFree: false, currency: null, allowNegative: false }"
        :rules="rules"
    ></v-text-field>
</template>
  
<script>
export default {
    model: {
        prop: 'value',
        event: 'update:value'
    },
    props: {
        value: {
            type: String,
            default: null
        },
        outlined: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => {}
        },
        index: {
            type: Number,
            default: null
        },
        rules: {
            type: Array,
            default: () => []
        }
    }
}
</script>